import { ethers } from 'ethers';

const ERC20_ABI = [
  {
    constant: true,
    inputs: [{ name: '_owner', type: 'address' }],
    name: 'balanceOf',
    outputs: [{ name: 'balance', type: 'uint256' }],
    type: 'function'
  },
  {
    constant: true,
    inputs: [],
    name: 'decimals',
    outputs: [{ name: '', type: 'uint8' }],
    type: 'function'
  }
];

const getTokenContract = (tokenAddress, provider) => {
  return new ethers.Contract(tokenAddress, ERC20_ABI, provider);
};

export const getTokenBalance = async (tokenAddress, walletAddress, decimals, provider) => {
  try {
    const contract = getTokenContract(tokenAddress, provider);
    const balanceBigNumber = await contract.balanceOf(walletAddress);
    const balanceAtomic = balanceBigNumber.toString();
    const balanceDecimal = formatTokenAmount(balanceAtomic, decimals);
    
    return {
      atomic: balanceAtomic,
      decimal: balanceDecimal
    };
  } catch (error) {
    console.error(`Error fetching balance for ${tokenAddress}:`, error);
    throw new Error(`Failed to fetch token balance: ${error.message}`);
  }
};

export const formatTokenAmount = (atomicAmount, decimals) => {
  if (!atomicAmount || atomicAmount === '0') {
    return '0.00';
  }

  const padded = atomicAmount.padStart(decimals + 1, '0');
  const splitPos = padded.length - decimals;
  const wholePart = padded.slice(0, splitPos) || '0';
  const fractionalPart = padded.slice(splitPos);
  const displayFractional = fractionalPart.slice(0, 2).padEnd(2, '0');
  
  return `${wholePart}.${displayFractional}`;
};

export const getTokenBalances = async (tokens, walletAddress, provider) => {
  if (!tokens || tokens.length === 0) {
    return [];
  }

  console.log(`🔍 Fetching balances for ${tokens.length} tokens...`);

  const balancePromises = tokens.map(async (token) => {
    try {
      const balanceData = await getTokenBalance(
        token.address,
        walletAddress,
        token.decimals,
        provider
      );

      return {
        symbol: token.symbol,
        address: token.address,
        decimals: token.decimals,
        balance: balanceData.atomic,
        balanceFormatted: `${balanceData.decimal} ${token.symbol}`
      };
    } catch (error) {
      console.error(`Failed to fetch balance for ${token.symbol}:`, error);
      
      return {
        symbol: token.symbol,
        address: token.address,
        decimals: token.decimals,
        balance: '0',
        balanceFormatted: `0.00 ${token.symbol}`,
        error: error.message
      };
    }
  });

  const results = await Promise.all(balancePromises);
  console.log('✅ Balances fetched:', results);
  
  return results;
};

export const filterNonZeroBalances = (balances) => {
  return balances.filter(token => {
    return token.balance !== '0' && token.balance !== '' && token.balance !== null;
  });
};

// ✅ REMOVED: getProvider() function
// Provider is now passed from parent component using Reown